<!-- The second tier: iOS's large title, for tab roots. Factory-owned.

     It goes INSIDE `<IonContent :fullscreen="true">`, which is what lets it
     scroll away and hand the screen's name up to the inline bar. That handover
     is Ionic's own, and it is the reason a tab root must not ALSO print its
     name as an `<h1>` in the content — that is how a screen ends up saying
     "Robots" in the bar and "The fleet" underneath it, or printing its own name
     twice outright.

     WHY IT RENDERS NOTHING OFF iOS. `collapse="condense"` is an iOS pattern and
     Ionic's own Material stylesheet hides it
     (`.header-md.header-collapse-condense { display: none }`) — so on Android
     the markup would be a header that exists, takes part in the accessibility
     tree, and paints nothing. Returning null keeps the DOM honest: on Android
     there is one bar, it carries the screen's name, and that is the Material
     pattern rather than a broken imitation of the iOS one. -->
<template>
  <IonHeader v-if="isIos" collapse="condense" class="app-largetitle">
    <IonToolbar>
      <IonTitle size="large">{{ title }}</IonTitle>
    </IonToolbar>
  </IonHeader>
</template>

<script setup>
import { IonHeader, IonToolbar, IonTitle } from '@ionic/vue';

defineProps({
  /** The screen's name — the SAME string the inline bar carries. */
  title: { type: String, required: true },
});

// Ionic stamps the resolved mode as a class on <html> during its own
// initialisation, which happens in main.js before the first component mounts,
// so this is available synchronously here and `?ionic:mode=ios` lands on it
// too. Read at setup rather than in onMounted: a ref flipped after mount would
// mount the header and then tear it down again on every Android screen.
const isIos = typeof document !== 'undefined'
  && document.documentElement.classList.contains('ios');
</script>
